export default __webpack_public_path__ + "static/media/1.8bf4e320.svg";